// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { defaultBranding } from './holiday-branding/default';
import { winterBranding } from './holiday-branding/winter';
import { BrandingConfiguration } from './theme.types';

/**
 * Theme configurations for applying customizations to the app around holiday periods.
 */
export const BRANDING_CONFIGURATIONS = {
  default: defaultBranding,
  winter: winterBranding
  // Potential future themes:
  //   spring,
  //   summer,
  //   fall,
  //   msGive,
  //   halloween,
  //   newYearsDay,
  //   chineseNewYear,
  //   juneteenth,
  //   breastcancerawarenessmonth/movember
};

export const getCurrentBrandingConfiguration = (date: Date = new Date(Date.now())): BrandingConfiguration => {
  return getCustomBrandingConfiguration(date) || BRANDING_CONFIGURATIONS.default;
};

export const getCustomBrandingConfiguration = (
  date: Date = new Date(Date.now())
): BrandingConfiguration | undefined => {
  // remove default, searching only for custom configs within the date range
  const customConfigKeys = Object.keys(BRANDING_CONFIGURATIONS).filter((key) => key !== 'default');
  const brandingConfigurations: BrandingConfiguration[] = customConfigKeys.map((key) => BRANDING_CONFIGURATIONS[key]);
  const currentCustomBrandingConfiguration = brandingConfigurations.find(
    // ignore year, only compare if the current month and day are within range
    (brandingConfiguration) =>
      brandingConfiguration.startDate.getMonth() <= date.getMonth() &&
      brandingConfiguration.startDate.getDate() <= date.getDate() &&
      brandingConfiguration.endDate.getMonth() >= date.getMonth() &&
      brandingConfiguration.endDate.getDate() >= date.getDate()
  );

  return currentCustomBrandingConfiguration;
};
